<div class="d-flex justify-content-end mb-2">
  <button
    class="btn btn-primary"
    (click)="onClickCreate()"
    [canSee]="[accessRights.Settings_write]"
    [canSee]="[accessRights.ConfigurationOptions_write]"
    type="button"
  >
    {{ 'general.create' | translate }}
  </button>
</div>

<section class="card">
  <operation-internal-event-table
    *ngIf="(operationInternalEvents$ | async)?.length"
    [tableData]="operationInternalEvents$ | async"
    (onBulkAction)="onBulkAction($event)"
    (onClickRow)="onClickRow($event)"
  ></operation-internal-event-table>
</section>

<div
  class="spinner-border"
  role="status"
  attr.aria-label="{{ 'general.loading' | translate }}"
  *ngIf="isLoading$ | async"
>
</div>
